import React from 'react';
import { FieldFormResultDetails } from 'classes';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import SkeletonForm from 'components/Shared/SkeletonForm';

const DetailsDisplay = ({ loaded, attributes }) => {
  const defaults = attributes;
  const props = {};

  FieldFormResultDetails.columns.forEach(r => {
    if (!r.hidden) {
      props[r.field] = {
        label: r.title,
        type: 'string'
      };
    }
  });

  const schema = {
    "$schema": "http://json-schema.org/draft-07/schema#",
    "title": "Details",
    "type": "object",
    "properties": props
  };


  return (
    loaded ?
        withExtension(DynamicForm, {schema, orientation: "Horizontal", defaultValues: defaults, hiddenProperties: [], readOnly: true, cardElevation: 0 })
      :
      <SkeletonForm />
  )
}

export default DetailsDisplay;